"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubAdminSettings = void 0;
var react_1 = __importStar(require("react"));
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
var Separator_1 = require("office-ui-fabric-react/lib/Separator");
var AiHubLoadingState_1 = __importDefault(require("../shared/AiHubLoadingState/AiHubLoadingState"));
var components_1 = require("../shared/components");
var FieldsSection_1 = require("./components/FieldsSection");
var SettingsHeader_1 = require("./components/SettingsHeader");
var SettingsStatusMessages_1 = require("./components/SettingsStatusMessages");
var SystemsSection_1 = require("./components/SystemsSection");
var WorkflowsSection_1 = require("./components/WorkflowsSection");
var use_ai_hub_settings_config_1 = require("./hooks/use-ai-hub-settings-config");
var use_system_type_filter_1 = require("./hooks/use-system-type-filter");
require("./styles/ai-hub-settings.scss");
/**
 * WsAiHubAdminSettings - public admin entry point for the AI Hub Settings
 * tab.
 *
 * Pure orchestrator: wires {@link useAiHubSettingsConfig} (saved/draft +
 * typed-action reducer) to {@link useSystemTypeFilter} (derived dropdown
 * state) and {@link useConfirmDialog} (delete confirmations). All identity
 * flows through stable `__clientId`s so reorderings or user-edited `id`
 * values do not perturb selection or new-item tracking.
 */
var WsAiHubAdminSettings = function () {
    var _a = use_ai_hub_settings_config_1.useAiHubSettingsConfig(), savedConfig = _a.savedConfig, draftConfig = _a.draftConfig, isLoading = _a.isLoading, isSaving = _a.isSaving, errorMessage = _a.errorMessage, successMessage = _a.successMessage, hasChanges = _a.hasChanges, changeFlags = _a.changeFlags, selectedSystemId = _a.selectedSystemId, setSelectedSystemId = _a.setSelectedSystemId, selectedWorkflowId = _a.selectedWorkflowId, setSelectedWorkflowId = _a.setSelectedWorkflowId, selectedFieldId = _a.selectedFieldId, setSelectedFieldId = _a.setSelectedFieldId, newSystemIds = _a.newSystemIds, newWorkflowIds = _a.newWorkflowIds, newFieldIds = _a.newFieldIds, addSystem = _a.addSystem, updateSystemField = _a.updateSystemField, updateSystemConfig = _a.updateSystemConfig, deleteSystem = _a.deleteSystem, discardSystemEdit = _a.discardSystemEdit, addWorkflow = _a.addWorkflow, updateWorkflowField = _a.updateWorkflowField, updateWorkflowSystems = _a.updateWorkflowSystems, deleteWorkflow = _a.deleteWorkflow, discardWorkflowEdit = _a.discardWorkflowEdit, addField = _a.addField, updateFieldName = _a.updateFieldName, toggleFieldIgnore = _a.toggleFieldIgnore, deleteField = _a.deleteField, discardFieldEdit = _a.discardFieldEdit, addMapping = _a.addMapping, removeMapping = _a.removeMapping, updateMapping = _a.updateMapping, saveChanges = _a.saveChanges, discardChanges = _a.discardChanges;
    var _b = use_system_type_filter_1.useSystemTypeFilter(draftConfig), systemTypeFilterSelectedKey = _b.selectedKey, setSystemTypeFilter = _b.setSelectedType, systemTypeFilterOptions = _b.filterOptions, filteredFields = _b.filteredFields, ALL_TYPES_KEY = _b.ALL_TYPES_KEY;
    var _c = components_1.useConfirmDialog(), confirm = _c.confirm, confirmDialog = _c.dialog;
    var systemOptions = react_1.useMemo(function () {
        if (!draftConfig) {
            return [];
        }
        return draftConfig.systems.map(function (system) { return ({
            key: system.id || '__empty__',
            text: system.id || '(Unnamed system)',
        }); });
    }, [draftConfig]);
    var confirmDelete = react_1.useCallback(function (targetLabel, impactMessage) {
        return confirm({
            title: "Delete " + targetLabel + "?",
            message: impactMessage || "Are you sure you want to delete " + targetLabel + "?",
            subText: "This action cannot be undone.",
            variant: 'error',
            confirmText: 'Delete',
        });
    }, [confirm]);
    // --- Systems ---------------------------------------------------------
    var handleDeleteSystem = react_1.useCallback(function (system, id) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, confirmDelete(system.id || 'this system', 'Deleting a system will also remove every field mapping connected to it.')];
                case 1:
                    confirmed = _a.sent();
                    if (!confirmed) {
                        return [2 /*return*/];
                    }
                    deleteSystem(id);
                    return [2 /*return*/];
            }
        });
    }); }, [confirmDelete, deleteSystem]);
    var handleStopSystemEdit = react_1.useCallback(function () { return setSelectedSystemId(null); }, [setSelectedSystemId]);
    // --- Workflows -------------------------------------------------------
    var handleDeleteWorkflow = react_1.useCallback(function (workflow, id) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, confirmDelete(workflow.id || workflow.name || 'this workflow')];
                case 1:
                    confirmed = _a.sent();
                    if (!confirmed) {
                        return [2 /*return*/];
                    }
                    deleteWorkflow(id);
                    return [2 /*return*/];
            }
        });
    }); }, [confirmDelete, deleteWorkflow]);
    var handleStopWorkflowEdit = react_1.useCallback(function () { return setSelectedWorkflowId(null); }, [setSelectedWorkflowId]);
    // --- Fields ----------------------------------------------------------
    var handleDeleteField = react_1.useCallback(function (field, id) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, confirmDelete(field.name || 'this field')];
                case 1:
                    confirmed = _a.sent();
                    if (!confirmed) {
                        return [2 /*return*/];
                    }
                    deleteField(id);
                    return [2 /*return*/];
            }
        });
    }); }, [confirmDelete, deleteField]);
    var handleStopFieldEdit = react_1.useCallback(function () { return setSelectedFieldId(null); }, [setSelectedFieldId]);
    var handleRemoveMapping = react_1.useCallback(function (fieldId, mappingId) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, confirmDelete('this mapping', 'The field will lose this system mapping.')];
                case 1:
                    confirmed = _a.sent();
                    if (!confirmed) {
                        return [2 /*return*/];
                    }
                    removeMapping(fieldId, mappingId);
                    return [2 /*return*/];
            }
        });
    }); }, [confirmDelete, removeMapping]);
    // --- Render ----------------------------------------------------------
    if (isLoading) {
        return react_1.default.createElement(AiHubLoadingState_1.default, { label: "Loading data sources" });
    }
    if (!draftConfig || !savedConfig) {
        return (react_1.default.createElement("div", { className: "ws-ai-hub-settings" },
            react_1.default.createElement("div", { className: "ws-ai-hub-settings-status" },
                react_1.default.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.error }, errorMessage || 'Could not load data sources. Please reload and try again.'))));
    }
    return (react_1.default.createElement("div", { className: "ws-ai-hub-settings" },
        react_1.default.createElement(SettingsHeader_1.SettingsHeader, { hasChanges: hasChanges, isSaving: isSaving, onSave: saveChanges, onDiscard: discardChanges }),
        react_1.default.createElement(SettingsStatusMessages_1.SettingsStatusMessages, { errorMessage: errorMessage, successMessage: successMessage }),
        react_1.default.createElement("div", { className: "ws-ai-hub-settings-content" },
            react_1.default.createElement(SystemsSection_1.SystemsSection, { draftConfig: draftConfig, selectedSystemId: selectedSystemId, newSystemIds: newSystemIds, changeFlags: changeFlags, onAddSystem: addSystem, onStartEdit: setSelectedSystemId, onStopEdit: handleStopSystemEdit, onDiscardEdit: discardSystemEdit, onDeleteSystem: handleDeleteSystem, onUpdateSystemField: updateSystemField, onUpdateSystemConfig: updateSystemConfig }),
            react_1.default.createElement(Separator_1.Separator, { className: "ws-ai-hub-settings-section-separator" }),
            react_1.default.createElement(WorkflowsSection_1.WorkflowsSection, { draftConfig: draftConfig, selectedWorkflowId: selectedWorkflowId, newWorkflowIds: newWorkflowIds, changeFlags: changeFlags, onAddWorkflow: addWorkflow, onStartEdit: setSelectedWorkflowId, onStopEdit: handleStopWorkflowEdit, onDiscardEdit: discardWorkflowEdit, onDeleteWorkflow: handleDeleteWorkflow, onUpdateWorkflowField: updateWorkflowField, onUpdateWorkflowSystems: updateWorkflowSystems }),
            react_1.default.createElement(Separator_1.Separator, { className: "ws-ai-hub-settings-section-separator" }),
            react_1.default.createElement(FieldsSection_1.FieldsSection, { draftConfig: draftConfig, selectedFieldId: selectedFieldId, newFieldIds: newFieldIds, systemOptions: systemOptions, filteredFields: filteredFields, systemTypeFilterOptions: systemTypeFilterOptions, systemTypeFilterSelectedKey: systemTypeFilterSelectedKey, systemTypeAllKey: ALL_TYPES_KEY, changeFlags: changeFlags, onAddField: addField, onSystemTypeFilterChange: setSystemTypeFilter, onStartEdit: setSelectedFieldId, onStopEdit: handleStopFieldEdit, onDiscardEdit: discardFieldEdit, onDeleteField: handleDeleteField, onUpdateFieldName: updateFieldName, onToggleFieldIgnore: toggleFieldIgnore, onAddMapping: addMapping, onMappingChange: updateMapping, onRemoveMapping: handleRemoveMapping })),
        confirmDialog));
};
exports.WsAiHubAdminSettings = WsAiHubAdminSettings;
